import React from "react";
import { useNavigate } from "react-router-dom";
import "../components/css/About.css";

const About: React.FC = () => {
  const navigate = useNavigate();

  const handleResumeClick = () => {
    navigate('/resume');
    window.scrollTo(0, 0);
  };
// 添加一个按钮，点击后跳转到resume页面
  return (
    <section
      id="about"
      className="w-full bg-[#F4F1EC] px-4 sm:px-6 md:px-8 py-16 sm:py-20 md:py-24 font-serif text-black"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-start">
          {/* 左边部分 */}
          <div className="mt-0 md:-mt-10">
            {/* 分隔线 */}
            <div className="h-[1px] w-full max-w-[200px] sm:max-w-[250px] md:max-w-[300px] bg-gray-300 mb-6 md:mb-8" />

            {/* 标题 */}
            <h2 className="about-title text-4xl sm:text-5xl md:text-6xl lg:text-7xl">About</h2>

            {/* 左边介绍 */}
            <div className="space-y-4 text-sm sm:text-base md:text-lg leading-relaxed font-sans max-w-full md:max-w-[90%] mt-6 md:mt-10">
              <p className="mt-8">
                I'm <strong>Celeste</strong>, a product designer exploring the
                intersection of UI/UX, interaction, and emerging technologies
                to create meaningful digital experiences.
              </p>
            </div>
          </div>

          {/* 右边用代码生成框 */}
          <div className="w-full relative mt-8 md:mt-0 border border-black px-4 sm:px-6 md:px-8 pt-16 sm:pt-20 md:pt-24 pb-8 md:pb-10 text-black rounded-lg">
            <div>
              <div className="space-y-4 sm:space-y-6 text-xs sm:text-sm md:text-base leading-relaxed font-sans font-normal">
                <p>
                  I am a product designer with a multidisciplinary background in graphic design, UX/UI, and illustration. With over eight years of experience in visual design, I bring a strong sense of aesthetics, storytelling, and craft into digital product experiences.
                </p>
                <p>
                  Before moving into product design, I founded a design and illustration studio in Shanghai and collaborated with internationally recognized brands such as Nike, Levi's, Johnnie Walker, and Havana Club. These experiences shaped my ability to create visually compelling work while responding to both user and business needs.
                </p>
                <p>
                  Now, I focus on designing digital products and interfaces that are intuitive, engaging, and visually refined. My goal is to create experiences that not only work well, but also feel meaningful and human.
                </p>
                <div className="flex justify-center mt-8 md:mt-10">
                  <button 
                    onClick={handleResumeClick}
                    className="px-4 sm:px-5 md:px-6 py-1 bg-[#B2FFFF] text-black border border-[#111827] rounded-[29px] font-serif text-xs sm:text-sm md:text-base font-medium h-[32px] sm:h-[34px] md:h-[38px] flex items-center transition-all duration-300 ease-in-out hover:-translate-y-2 hover:shadow-[0_8px_0_0_#000000] active:translate-y-0 active:shadow-[0_2px_0_0_#000000] relative"
                  >
                    SEE FULL RESUME
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
